import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import type { EstadoLicitacion, Prioridad } from "@/types/licitacion";

interface EstadoConfigEntry { label: string; className: string; }

export const estadoConfig: Record<EstadoLicitacion, EstadoConfigEntry> = {
  BORRADOR: { label: "Borrador", className: "bg-gray-100 text-gray-700" },
  EN_ANALISIS: { label: "En An\u00e1lisis", className: "bg-yellow-100 text-yellow-700" },
  EN_PREPARACION: { label: "En Preparaci\u00f3n", className: "bg-blue-100 text-blue-700" },
  PRESENTADA: { label: "Presentada", className: "bg-purple-100 text-purple-700" },
  EN_EVALUACION: { label: "En Evaluaci\u00f3n", className: "bg-indigo-100 text-indigo-700" },
  ADJUDICADA: { label: "Adjudicada", className: "bg-green-100 text-green-700" },
  RECHAZADA: { label: "Rechazada", className: "bg-red-100 text-red-700" },
  DESIERTA: { label: "Desierta", className: "bg-gray-200 text-gray-600" },
  CANCELADA: { label: "Cancelada", className: "bg-gray-200 text-gray-600" },
};

export function EstadoBadge({ estado, className }: { estado: EstadoLicitacion | null | undefined; className?: string }) {
  if (!estado || !estadoConfig[estado]) return null;
  const config = estadoConfig[estado];
  return <Badge variant="outline" className={cn("border-transparent", config.className, className)}>{config.label}</Badge>;
}

export const prioridadConfig: Record<Prioridad, EstadoConfigEntry> = {
  BAJA: { label: "Baja", className: "bg-green-100 text-green-700" },
  MEDIA: { label: "Media", className: "bg-yellow-100 text-yellow-700" },
  ALTA: { label: "Alta", className: "bg-orange-100 text-orange-700" },
  URGENTE: { label: "Urgente", className: "bg-red-100 text-red-700" },
};

export function PrioridadBadge({ prioridad, className }: { prioridad: Prioridad | null | undefined; className?: string }) {
  if (!prioridad || !prioridadConfig[prioridad]) return null;
  const config = prioridadConfig[prioridad];
  return <Badge variant="outline" className={cn("border-transparent", config.className, className)}>{config.label}</Badge>;
}
